import {
  IOrgMasterHierachyList, INewAndExistReservationClientCourse, IBookingOnlineNewCustomer, IBookingOnlineOldCustomer, IBookingCalendar, IResponseHolidayData, IBookingCalendarDetail, IStatusCalendar, IReservationClient, IContractCourseCategorys, validateBookingOnlineOldCustomer,
} from 'pages/reservationBookingOnline/type';
import axios from 'axios';
import { stringify } from 'qs';
import { IReservationStoreSettingDetail } from 'pages/reservationManagement/storeSetting/type';
import { IReserberationMedias } from 'pages/customer/type';

const domainUrl = process.env.REACT_APP_API_BASE_URL;
export const addOnlineReservationsNewCustomer = async (params: IBookingOnlineNewCustomer, mediaCode:string): Promise<any> => {
  if (!mediaCode) {
    const { data } = await axios.post(`${domainUrl}/v1/onlineReservations/newCustomer`, params);
    return data;
  }
  const { data } = await axios.post(`${domainUrl}/v1/onlineReservations/newCustomer?mediaCode=${mediaCode}`, params);
  return data;
};

export const validateOnlineReservationOldCustomer = async (params:validateBookingOnlineOldCustomer):Promise<any> => {
  const { data } = await axios.post(`${domainUrl}/v1/onlineReservations/createFrame?${stringify(params)}`);
  return data;
};

export const addOnlineReservationOldCustomer = async (params:IBookingOnlineOldCustomer):Promise<any> => {
  const { data } = await axios.post(`${domainUrl}/v1/onlineReservations/oldCustomer`, params);
  return data;
};

export const getOnlineHoliday = async (params:IBookingCalendar):Promise<IResponseHolidayData> => {
  const { data } = await axios.get(`${domainUrl}/v1/reservations/bookingCalendar?${stringify(params)}`);
  return data;
};

export const getBookingCalendars = async (params:IBookingCalendarDetail):Promise<IStatusCalendar[]> => {
  const { data } = await axios.get(`${domainUrl}/v1/reservations/bookingCalendars?${stringify(params)}`);
  return data;
};


export const getContractCourseCategorys = async (params:{keyWord:string, companyCode:string, validFlag:number}):Promise<IContractCourseCategorys[]> => {
  const { data } = await axios.get(`${domainUrl}/v1/contractCourseCategorys?${stringify(params)}`);
  return data;
};

export const getReservationNewClient = async (
  params:{
    keyword:string,
    companyCode:string,
    validFlag:number,
    targetDate:string,
    menuSearchType:string,
    orgIds:string,
    featureCode:string,
    isAppluUnderOrg:boolean,
  },
):Promise<IReservationClient[]> => {
  const { data } = await axios.get(`${domainUrl}/v1/reservationNewClients?${stringify(params)}`);
  return data;
};
export const getReservationExistingClient = async (
  params:{
    keyWord:string,
    companyCode:string,
    targetDate:string,
    menuSearchType:string,
    orgIds:string,
    featureCode:string,
    isAppluUnderOrg:boolean,
  },
):Promise<IReservationClient[]> => {
  const { data } = await axios.get(`${domainUrl}/v1/reservationExistingClientCourse?${stringify(params)}`);
  return data;
};

export const getNewAndExistReservationClientCourse = async (params:{coustomerClass:string, categoryId?:string, companyCode:string}):Promise<INewAndExistReservationClientCourse[]> => {
  const { data } = await axios.get(`${domainUrl}/v1/reservationClientCourse/newAndExisting?${stringify(params)}`);
  const filterData = (data as INewAndExistReservationClientCourse[]).filter((item, index, self) => index === self.findIndex((l) => l.courseId === item.courseId));
  return filterData;
};
// Get OrgMasterList Hierachy
export const getOrgMasterHierachyListApi = async (params: { targetDay: string, companyCode: string, followingIds?: string }): Promise<IOrgMasterHierachyList[]> => {
  const { data } = await axios.get(`${domainUrl}/v1/organizations/organizationtree/online?${stringify(params)}`);
  return data;
};

export const getHeadQuarterApi = async (companyCode:string): Promise<IHeadQuarterData> => {
  const { data } = await axios.get(`${domainUrl}/v1/reservationHeadquartersSettings/${companyCode}`);
  return data;
};
export const getStoreSettingDetailApi = async (params: { orgId: string, companyCode: string}): Promise<IReservationStoreSettingDetail> => {
  // const { data } = await ApiClient.get(`/v1/reservation/storeSetting/${companyCode}`, params);
  const { data } = await axios.get(`${domainUrl}/v1/reservation/storeSetting?${stringify(params)}`);
  return data;
};

export const getReverberationMediasPublic = async (params: { companyCode: string}):Promise<IReserberationMedias[]> => {
  const { data } = await axios.get(`${domainUrl}/v1/publicMedia/?${stringify(params)}`);
  return data;
};
export const sentMailReservation = async (params:{companyCode:string, reservationId:string, customerType:string}) => {
  const { data } = await axios.post(`${domainUrl}/v1/onlineReservations/sendMail`, params);
  return data;
};

export const getInfoCustomerApi = async (companyCode:string, params: { mailAddress:string, phoneNumber:string}):Promise<any> => {
  const { data } = await axios.get(`${domainUrl}/v1/customers/checkExists/${companyCode}?${stringify(params)}`);
  return data;
};

export interface IHeadQuarterData{
  companyCode:string;
  createDate:HeadQuarterDate;
  note:string;
  updateDate:HeadQuarterDate;
  updateUser:string;
  linkLabel:string;
  linkUrl:string;
}
export interface HeadQuarterDate{
  date:number;
  day:number;
  hours:number;
  minutes:number;
  month:number;
  nanos:number;
  seconds:number;
  time:number;
  timezoneOffset:number;
  year:number;
}
